import type { CharacterStay, RailBranch } from "@/data/rail-branches";

/** Stay belongs to this branch's site and overlaps its time window. */
export function stayOverlapsBranch(
  stay: CharacterStay,
  branch: Pick<RailBranch, "rootPlaceId" | "startMs" | "endMs">,
): boolean {
  if (stay.rootPlaceId !== branch.rootPlaceId) {
    return false;
  }
  return stay.endMs > branch.startMs && stay.startMs < branch.endMs;
}
